// extracted by mini-css-extract-plugin
export default {"AutoCompleteInputStyle":"AutoCompleteMUI_AutoCompleteInputStyle__M-8NY"};